import { Schemas } from '~/api/gen'
import { Shop } from '~/components/modules/Shop'

type Props = {
  shop: Schemas.shop_with_brands
}

export const ShopInfo: React.FC<Props> = ({ shop }) => {
  return (
    <section>
      <h2 className="text-[14px] font-bold leading-[1.4]">所属店舗</h2>
      <div className="mt-3">
        <Shop shop={shop} />
      </div>
    </section>
  )
}
